import axios, {
  type AxiosError,
  type AxiosRequestConfig,
  HttpStatusCode,
} from 'axios'
import { toast } from 'sonner'

import { rollbar } from '@/modules/shared/infra/rollbar.config'
import { removeItemFromStorage } from '@/modules/shared/utils/storage-helper'
import { env } from '../infra/env'

const commonOptions: AxiosRequestConfig = {
  baseURL: env.VITE_API_URL,
  headers: {
    'Content-Type': 'text/plain',
  },
}

export const api = axios.create(commonOptions)

api.interceptors.request.use(
  (config) => {
    config.timeout = 60000 * 3 // 2 minutes
    config.timeoutErrorMessage =
      'Tempo de requisição excedido. Por favor, tente novamente.'

    return config
  },
  (error) => {
    rollbar.error(error)
    return Promise.reject(error)
  },
)

api.interceptors.response.use(
  (response) => {
    if (
      response.data.status === HttpStatusCode.Unauthorized ||
      response.status === HttpStatusCode.Unauthorized
    ) {
      toast.info('Sessão expirada.', {
        description: 'Por favor, faça login novamente.',
      })

      removeItemFromStorage('auth')

      setTimeout(() => {
        window.location.reload()
      }, 1000)
    }

    return response
  },
  (error: AxiosError) => {
    return Promise.reject(error)
  },
)
